import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';

import ContentStructureToast from '../../components/ContentStructureToast';
import { initializeOfflineManager, closeContentStructureToast } from '../OfflineManager/actions';
import UserAgentUtils from '../../utils/userAgent';
import { DownloadGroupStatus } from '../DownloadManager/reducer';

const mapStateToProps = (state: StoreState) => {
	const {
		offlineManager,
		downloadManager: {
			downloadGroups,
			isDownloadToastClosed,
		},
	} = state;

	const isPreparingContentStructure = offlineManager.isPreparingContentStructure;
	const isContentStructureToastClosed = offlineManager.isContentStructureToastClosed;

	// Check if download manager widget is active
	const isDownloadGroupStarted = [
		downloadGroups.all.status,
		downloadGroups.important.status,
		downloadGroups.selected.status,
	].includes(DownloadGroupStatus.Started);
	const isDownloadManagerActive = isDownloadGroupStarted && !isDownloadToastClosed;

	// Check if content structure was never completed
	// When offline, always show widget if content structure was never completed, regardless of status
	// When online, only show widget if content structure is actively being prepared/initialized
	// This prevents showing the "incomplete" message when online and not actively preparing
	const isOffline = !UserAgentUtils.isOnline();
	const needsContentStructureCompletion = !offlineManager.contentStructureEverCompleted && (
		isOffline  // Only show "incomplete" message when offline
	);

	// Show widget if:
	// - Content structure is being prepared/updated
	// - Content structure is ready (to show completion message or thumbnail download progress)
	// - Thumbnails are still downloading (keep widget open until they're done)
	// - OR we need content structure completion (offline with incomplete structure, or online actively preparing incomplete structure)
	// But respect user's choice to close it (unless needsContentStructureCompletion is true, which is critical)
	const shouldShow = (isPreparingContentStructure || offlineManager.contentStructureReady || offlineManager.isDownloadingThumbs || needsContentStructureCompletion);
	const isDisplayed = shouldShow && (!isContentStructureToastClosed || needsContentStructureCompletion);

	return {
		isDisplayed,
		isPreparingContentStructure,
		contentStructureReady: offlineManager.contentStructureReady,
		needsContentStructureCompletion,
		contentStructureEverCompleted: offlineManager.contentStructureEverCompleted,
		isDownloadingThumbs: offlineManager.isDownloadingThumbs,
		isDownloadManagerActive,
	};
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
	onRetryContentStructure: () => {
		dispatch(initializeOfflineManager());
	},
	onClose: () => {
		dispatch(closeContentStructureToast());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentStructureToast);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ContentStructureToast/index.tsx